import { ChatActions } from "src/base-components/Chat/ChatActions";
import { ChatBody } from "src/base-components/Chat/ChatBody";
import { ChatEmptyState } from "src/base-components/Chat/ChatEmptyState";
import { ChatInput } from "src/base-components/Chat/ChatInput";
import { ChatInputArea } from "src/base-components/Chat/ChatInputArea";
import { ChatLoadingIndicator } from "src/base-components/Chat/ChatLoadingIndicator";
import { ChatMessage } from "src/base-components/Chat/ChatMessage";
import { ChatMessageList } from "src/base-components/Chat/ChatMessageList";
import { ChatTextContent } from "src/base-components/Chat/ChatTextContent";
import { ChatToolApproval } from "src/base-components/Chat/ChatToolApproval";
import { ChatToolResult } from "src/base-components/Chat/ChatToolResult";

export const Chat = {
  Body: ChatBody,
  MessageList: ChatMessageList,
  Message: ChatMessage,
  TextContent: ChatTextContent,
  LoadingIndicator: ChatLoadingIndicator,
  EmptyState: ChatEmptyState,
  InputArea: ChatInputArea,
  Input: ChatInput,
  ToolApproval: ChatToolApproval,
  ToolResult: ChatToolResult,
  Actions: ChatActions,
};
